<template>
    <div>
        <avue-crud :data="data" :option="option" :page.sync="page" :search.sync="search" @current-change="changePage" @search-change="searchChange" @search-reset="resetChange">
            <template slot="menuBtn" slot-scope="scope">
<!--                <el-button  class="View">签署</el-button>-->
                <el-dropdown-item  class="pull-down" @click.native="revocationBtn(scope.row)" v-if="scope.row.is_faqiren==1">作废</el-dropdown-item>

                <el-dropdown-item  class="pull-down" @click.native="viewBtn(scope.row)" >查看</el-dropdown-item>

            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="system_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.system_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.system_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="all_signers" slot-scope="scope" >
                <el-tooltip :content="scope.row.all_signers" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.all_signers }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <!--        作废-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <span>请确认是否要作废该合同</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { contractList, contractSearch, revocationContract } from '../../../api/contract';

    export default {
        name: "treatOthers",
        inject: ['reload'],
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [],
                dialogVisible:false,
                doc_title:'',
                all_signers:'',
                pages:1,
                search:{
                    doc_title:'',
                    all_signers:''
                },
                option:{
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    align:'center',
                    menuAlign:'center',
                    editBtn:false,
                    delBtn:false,
                    menuWidth:150,//操作栏宽度设置
                    rowKey:'ids',
                    refreshBtn: false, //刷新按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    addBtn:false, //左上角新增
                    column:[
                        {
                            label:'合同名称',
                            prop:'doc_title',
                            search:true
                        }, {
                            label:'平台编号',
                            prop:'system_sn',
                        },
                        // {
                        //     label:'合同编号',
                        //     prop:'contract_sn',
                        // },
                        {
                            label:'发起人',
                            prop:'faqi_ren'
                        },  {
                            label:'发起时间',
                            prop:'faqi_time'
                        },  {
                            label:'参与人',
                            prop:'all_signers',
                            width:'500',
                            search: true
                        },  {
                            label:'合同状态',
                            prop:'ct_status_txt'
                        },  {
                            label:'合同完成时间',
                            prop:'finish_time'
                        },  {
                            label: '签署截止时间',
                            prop: 'expire_time'
                        }

                    ]
                },
            };
        },
        methods:{
            //分页
            changePage(num){
                if (this.doc_title==''&&this.all_signers==''){
                    contractList(4,10,num).then(res=>{
                        sessionStorage.setItem('treatOthers',num)
                        this.data=res.data.list
                        this.page.total=res.data.count
                    })
                }else {
                    //搜索后分页
                    contractSearch(4,10,num,this.doc_title,this.all_signers).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('treatOthersSearch', num)
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }
            },
            //搜索
            searchChange(from,done){
                contractSearch(4,10,1,from.doc_title,from.all_signers).then(res=>{
                    this.doc_title=from.doc_title
                    this.all_signers=from.all_signers
                    if (res.code==200){
                        sessionStorage.setItem('treatOthersSearch', 1)
                        sessionStorage.setItem('treatOthersParams', JSON.stringify(from) )
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
                done()
            },
            //重置搜索
            resetChange(){
                this.doc_title=''
                this.all_signers=''
                contractList(4,10,this.pages).then(res=>{
                    if (res.code==200){
                        sessionStorage.removeItem('treatOthers')
                        sessionStorage.removeItem('treatOthersSearch')
                        sessionStorage.removeItem('treatOthersParams')
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                        this.$message.success('重置成功')
                    }

                })
            },
            //查看
            viewBtn(row){
                this.$router.push({path:'/detailsPage',query:{id:row.id}})
            },
            //作废
            revocationBtn(row){
                this.dialogVisible=true
                this.id=row.id

            },
            confirmBtn(){
                revocationContract(this.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            }
        },
        created() {
            if (sessionStorage.getItem('treatOthersSearch')){
                let treatOthersParams=JSON.parse(sessionStorage.getItem('treatOthersParams'))
                this.search=treatOthersParams
                this.doc_title=treatOthersParams.doc_title
                this.all_signers=treatOthersParams.all_signers
                contractSearch(4,10,sessionStorage.getItem('treatOthersSearch'),this.doc_title,this.all_signers).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('treatOthersSearch')
                    }
                })
            }else {
                if (sessionStorage.getItem('treatOthers')===null){
                    contractList(4,10,this.pages).then(res=>{
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    })
                }else {
                    contractList(4,10,sessionStorage.getItem('treatOthers')).then(res=>{
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('treatOthers')
                    })
                }
            }

        }
    }
</script>

<style scoped>
    /deep/.el-col{
        width: 25%;
    }
    /deep/.avue-form__menu{
        padding: 0px;
    }
    /deep/ .el-tabs__active-bar{
        background-color: #3d62f6;
    }
    .View{
        background: #3d62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
    ::v-deep .avue-crud__menu{
        min-height:0px !important;
        height: 0px !important;
    }
</style>
